<!--
  @Description 看板单元
  @Date 2022-01-08
  @Author liushuo
-->
<template>
  <div class="dashboard-container">
    <!-- 标题 -->
    <div class="title-dv" :class="titleClass">
      <div class="title-text">
        <i :class="icon"></i>
        <p>{{ title }}</p>
      </div>
      <div class="title-length">
        <p>{{ data.length || 0 }}</p>
      </div>
    </div>

    <!-- 内容 -->
    <div class="content-dv">
      <!-- 每一个菜单 -->
      <div class="item-dv" v-for="(item, index) of data" :key="index">
        <div class="left-dv">
          <!-- 页面名 -->
          <div class="top-dv vuePath-dv">
            {{ item.vuePath }}
          </div>
          <!-- 模块名 -->
          <div class="bottom-dv group-dv">
            <span>{{ item.groupName }}</span>
          </div>
        </div>

        <!-- 研发 -->
        <div class="schedule-dv" v-if="type === '研发'">
          <!-- 前端研发 -->
          <div class="top-dv">
            {{ item.frontEngineer }}
          </div>
          <!-- 前端进度 -->
          <div
            class="bottom-dv"
            :class="item.frontWorkPercentage === 0 ? 'textDanger' : ''"
          >
            {{ item.frontWorkPercentage + '%' }}
          </div>
        </div>
        <div class="schedule-dv" v-if="type === '研发'">
          <!-- 后端研发 -->
          <div class="top-dv">
            {{ item.backEngineer }}
          </div>
          <!-- 后端进度 -->
          <div
            class="bottom-dv"
            :class="item.backWorkPercentage === 0 ? 'textDanger' : ''"
          >
            {{ item.backWorkPercentage + '%' }}
          </div>
        </div>

        <!-- 测试 -->
        <div class="schedule-dv" v-if="type === '测试'">
          <!-- 技术测试 -->
          <div class="top-dv">
            {{ item.techTester }}
          </div>
          <!-- 技术测试进度 -->
          <div
            class="bottom-dv"
            :class="item.techTestPercentage === 0 ? 'textDanger' : ''"
          >
            {{ item.techTestPercentage + '%' }}
          </div>
        </div>
        <div class="schedule-dv" v-if="type === '测试'">
          <!-- 业务测试 -->
          <div class="top-dv">
            {{ item.businessTester }}
          </div>
          <!-- 业务测试进度 -->
          <div
            class="bottom-dv"
            :class="item.businessTestPercentage === 0 ? 'textDanger' : ''"
          >
            {{ item.businessTestPercentage + '%' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dashboard',
  props: {
    // 列表数据
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 标题文字
    title: {
      type: String,
      default: '',
    },
    // 标题样式 [danger|normal|success]
    titleClass: {
      type: String,
      default: '',
    },
    // 类型[研发|测试]，根据该字段来显示研发进度或测试进度
    type: {
      type: String,
      default: ''
    },
    // 标题图标
    icon: {
      type: String,
      default: 'el-icon-s-order'
    }
  },
  data () {
    return {
      // 测试数据，后续可删
      listdata: [
        {
          vuePath: "设备日常保养计划",
          groupName: "设备管理",
          frontEngineer: '刘铄',
          backEngineer: '陈天生',
          frontWorkPercentage: 20,
          backWorkPercentage: 20,
        },
        {
          vuePath: "设备日常保养计划",
          groupName: "设备管理",
          frontEngineer: '刘铄',
          backEngineer: '陈天生',
          frontWorkPercentage: 20,
          backWorkPercentage: 20,
        },
        {
          vuePath: "设备日常保养计划",
          groupName: "设备管理",
          frontEngineer: '刘铄',
          backEngineer: '陈天生',
          frontWorkPercentage: 20,
          backWorkPercentage: 20,
        },
        {
          vuePath: "设备日常保养计划",
          groupName: "设备管理",
          frontEngineer: '刘铄',
          backEngineer: '陈天生',
          frontWorkPercentage: 20,
          backWorkPercentage: 20,
        },
        {
          vuePath: "设备日常保养计划",
          groupName: "设备管理",
          frontEngineer: '刘铄',
          backEngineer: '陈天生',
          frontWorkPercentage: 20,
          backWorkPercentage: 20,
        },
        {
          vuePath: "设备日常保养计划",
          groupName: "设备管理",
          frontEngineer: '刘铄',
          backEngineer: '陈天生',
          frontWorkPercentage: 20,
          backWorkPercentage: 20,
        },
        {
          vuePath: "设备日常保养计划",
          groupName: "设备管理",
          frontEngineer: '刘铄',
          backEngineer: '陈天生',
          frontWorkPercentage: 20,
          backWorkPercentage: 20,
        },
        {
          vuePath: "设备日常保养计划",
          groupName: "设备管理",
          frontEngineer: '刘铄',
          backEngineer: '陈天生',
          frontWorkPercentage: 20,
          backWorkPercentage: 20,
        },
        {
          vuePath: "设备日常保养计划",
          groupName: "设备管理",
          frontEngineer: '刘铄',
          backEngineer: '陈天生',
          frontWorkPercentage: 20,
          backWorkPercentage: 20,
        },
        {
          vuePath: "设备日常保养计划",
          groupName: "设备管理",
          frontEngineer: '刘铄',
          backEngineer: '陈天生',
          frontWorkPercentage: 20,
          backWorkPercentage: 20,
        },
        {
          vuePath: "设备日常保养计划",
          groupName: "设备管理",
          frontEngineer: '刘铄',
          backEngineer: '陈天生',
          frontWorkPercentage: 20,
          backWorkPercentage: 20,
        },
        {
          vuePath: "设备日常保养计划",
          groupName: "设备管理",
          frontEngineer: '刘铄',
          backEngineer: '陈天生',
          frontWorkPercentage: 20,
          backWorkPercentage: 20,
        },
        {
          vuePath: "设备日常保养计划",
          groupName: "设备管理",
          frontEngineer: '刘铄',
          backEngineer: '陈天生',
          frontWorkPercentage: 20,
          backWorkPercentage: 20,
        },
        {
          vuePath: "设备日常保养计划1",
          groupName: "设备管理",
          frontEngineer: '刘铄',
          backEngineer: '陈天生',
          frontWorkPercentage: 20,
          backWorkPercentage: 20,
        },
      ]
    }
  }
}
</script>

<style lang="less" scoped>
@titleHeight: 35px;
.dashboard-container {
  height: 100%;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #f2f3f5;
  box-shadow: #e2e2e2 0px 0px 3px;
}

.title-dv {
  width: 100%;
  height: @titleHeight;
  font-size: 16px;
  display: flex;
  border-radius: 10px;
  box-shadow: #dddddd 1px 1px 3px;

  .title-text {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    font-family: PingFang SC, sans-serif;

    > i {
      margin: 0 5px 0 10px;
    }
    > p {
    }
  }
  .title-length {
    box-sizing: border-box;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 8px;
    font-size: 18px;
  }
}

.content-dv {
  height: calc(100% - @titleHeight);
  width: 100%;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
}
.item-dv {
  min-height: 60px;
  width: 100%;
  margin: 5px 0;
  display: grid;
  // border-radius: 5px;
  grid-template-columns: 2fr 1fr 1fr;
  background-color: #ffffff;
  box-shadow: #e2e2e2 1px 1px 2px;

  .left-dv {
    box-sizing: border-box;
    padding: 10px;
    height: 100%;

    .left-vuepath-dv {
      height: 60%;
      width: 100%;
    }
    .left-group-dv {
      height: 40%;
      width: 100%;
    }
  }

  .schedule-dv {
    height: 100%;
    display: flex;
    flex-wrap: wrap;
  }
}

.top-dv {
  width: 100%;
  font-size: 14px;
  .fl(flex, center,flex-end);
}

.bottom-dv {
  width: 100%;
  font-size: 12px;
  color: #999999;
  .fl(flex, center, flex-start);
}

.group-dv {
  margin-top: 5px;
  .fl(flex, flex-start, flex-start);
  > span {
    background-color: #e3ecfb;
    color: #4874df;
    padding: 2px 5px;
    border-radius: 5px;
  }
}

.vuePath-dv {
  .fl(flex, flex-start, flex-start);
}

.textDanger {
  color: #ff8b8b;
}

.danger {
  background-color: #ff8b8b;
  color: #f9f7e8;
}
.normal {
  background-color: #f9f7e8;
  color: #61bfad;
}
.success {
  background-color: #61bfad;
  color: #ffffff;
}
</style>
